import React, {Component} from "react"
import {cloneDeep, merge, omit} from "lodash"

import {injectIntl, InjectIntl} from "@irati/utils/lang"
import authentication from "@irati/auth"
import Hr from "@irati/ui/src/Layout/Hr"
import teamService from "@irati/identity/services/teams"
import {Team} from "@irati/types"
import TeamName from "@irati-web/fields/team/PublicName"
import Form from "@irati/ui/src/Form"
import GenericModal from "@irati/ui/src/GenericModal"

interface Props extends InjectIntl {
  team: Team,
  show: boolean,
  onHide: () => void,
  onSuccess: () => void
}

interface State {
  name: string,
  submit: Promise<any> | null
}

class EditTeamNamePopUp extends Component<Props, State> {
  state: State = {
    name: this.props.team.public_name,
    submit: null
  }

  handleChange = (name: string) => {
    this.setState({
      name,
      submit: null
    })
  }

  handleHide = () => {
    this.setState({
      name: this.props.team.public_name
    })
    this.props.onHide()
  }

  handleSave = () => {
    const {team} = this.props
    const data = merge(omit(cloneDeep(team), "users"), {public_name: this.state.name.trim()})
    const submit = teamService.update(authentication.userTenant().uuid, data, team.Etag).then(() => this.props.onSuccess())

    this.setState({
      submit
    })
  }

  render() {
    const {show, team} = this.props
    const {submit, name} = this.state

    return (
      <div>
        <GenericModal
          title={team.public_name}
          show={show}
          onHide={this.handleHide}
          onConfirm={this.handleSave}
          dismissButtonText="platform.components.areYouSurePopUp.button.cancel"
          proceedButtonText="admin.components.editTeamPopUp.validationButton.save"
          load={submit}>
          <Hr solid />
          <Form>
            <TeamName onChange={this.handleChange} value={name} />
          </Form>
        </GenericModal>
      </div>
    )
  }
}

export default injectIntl(EditTeamNamePopUp, {withRef: true})
